angular.module('zc.commonApi')

.factory 'ProjectItemListPrice', ($resource, $q, BaseProjectCrudService) ->
  class ProjectItemListPrice extends BaseProjectCrudService

  new ProjectItemListPrice(
    $resource
    $q
    '/api/projects/:projectId/item_list_prices/:id'
    'item_list_price'
    'item_list_prices'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/item_list_price.service.coffee